import { useCallback, useState } from "react";

export const chatMessage = (role, content = "") => ({ id: crypto.randomUUID(), role, content });

export function useChatMessages() {
  const [messages, setMessages] = useState(() => [chatMessage("assistant", "JARVIS online. All subsystems nominal. Awaiting your command.")]);
  const append = useCallback((...entries) => setMessages((current) => [...current, ...entries]), []);
  const patch = useCallback((id, changes) => setMessages((current) => current.map((message) => message.id === id ? { ...message, ...changes } : message)), []);
  const delta = useCallback((id, text) => setMessages((current) => current.map((message) => message.id === id ? { ...message, content: message.content + text } : message)), []);
  return { messages, append, patch, delta };
}
